var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-title",class:{
    'ui-title--large': _vm.large,
    'ui-title--default': !_vm.large && !_vm.small,
    'ui-title--small': _vm.small,
    'ui-title--centered': _vm.centered,
  }},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }